import { ImageWithMetadata, resizeToHeight } from '@features/powerpoint';
import {
  ImageProps,
  SlideMasterPropsObject,
  TextPropsTextConfig,
  inmarketLogo,
  inmarketLogoShape,
} from '@features/powerpoint';

export const DEFAULT_SLIDE_MASTER = 'MASTER_SLIDE';
const BRAND_LOGO_HEIGHT = 0.41;
const BRAND_LOGO_Y_POSITION = 0.16;

export const buildSlideMasterHeader = (
  brandLogoWithMetadata: ImageWithMetadata | null
): SlideMasterPropsObject[] => {
  const brandLogoImageProps: ImageProps = (() => {
    if (!brandLogoWithMetadata) return {};

    const resizedBrandLogo = resizeToHeight(
      brandLogoWithMetadata,
      BRAND_LOGO_HEIGHT
    );

    const yPosition =
      resizedBrandLogo.height < BRAND_LOGO_HEIGHT
        ? BRAND_LOGO_Y_POSITION +
          (BRAND_LOGO_HEIGHT - resizedBrandLogo.height) / 2
        : BRAND_LOGO_Y_POSITION;

    return {
      data: resizedBrandLogo.data,
      x: 1.95,
      y: yPosition,
      w: resizedBrandLogo.width,
      h: resizedBrandLogo.height,
    };
  })();

  return [
    {
      image: {
        path: inmarketLogo,
        x: 0.29,
        y: 0.29,
        w: 1.2,
        h: 0.21,
      },
    },
    {
      line: {
        line: { color: '7F7F7F', width: 0 },
        x: 1.76,
        y: 0.12,
        w: 0,
        h: 0.47,
      },
    },
    {
      image: brandLogoImageProps,
    },
  ];
};

type FooterTextOptions = {
  text: string;
  color?: string;
};

export const buildSlideMasterFooterText = (options: FooterTextOptions) =>
  ({
    text: options.text,
    options: {
      x: 0.78,
      y: 7.01,
      w: 4.06,
      h: 0.12,
      fontSize: 6,
      color: options?.color ?? 'FFFFFF',
    },
  }) satisfies TextPropsTextConfig;

export const buildSlideMasterFooter = (
  options: FooterTextOptions
): SlideMasterPropsObject[] => {
  return [
    {
      image: {
        path: inmarketLogoShape,
        x: 0.31,
        y: 6.79,
        w: 0.15,
        h: 0.45,
      },
    },
    {
      text: buildSlideMasterFooterText(options),
    },
  ];
};
